import { render } from "./InvoiceContent.vue?vue&type=template&id=28c0255b"
import script from "./InvoiceContent.vue?vue&type=script&lang=js"
export * from "./InvoiceContent.vue?vue&type=script&lang=js"

import "./InvoiceContent.vue?vue&type=style&index=0&id=28c0255b&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__